import * as complianceReducer from "../reducers/complianceReducer";

// This file is anticipated to have multiple exports
// eslint-disable-next-line import/prefer-default-export
export const { getMineComplianceInfo } = complianceReducer;
